module.exports = __webpack_public_path__ + "img/expoglitter_0962_red.5e706641.jpg";